import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(app)/program/_components/ProgramSection.tsx");
